import { Controller } from "@hotwired/stimulus"

// Toggles "edit mode" on an exercise card, which reveals per-set delete buttons and the
// remove-exercise control (everything tagged .wk-edit-only) via CSS.
export default class extends Controller {
  toggle() {
    this.element.classList.toggle("wk-editing")
  }

  // Optimistic completion: flip the row's visual state instantly — before the
  // server round-trip lands and replaces the card — so tapping ✓ feels snappy
  // on a phone. The turbo_stream response reconciles the authoritative state
  // (progress bar, rest timer, which row is "active") a moment later.
  toggleSet(event) {
    const row = event.target.closest(".wk-set")
    if (!row) return

    const done = row.classList.toggle("wk-set-done")
    if (done) {
      row.classList.remove("wk-set-active")
      this.popRow(row)
    }
  }

  // One-shot pop, restartable on rapid taps. Driven from the tap (not from the
  // presence of .wk-set-done) so it never replays when the server re-renders
  // already-completed rows.
  popRow(row) {
    row.classList.remove("wk-pop")
    void row.offsetWidth
    row.classList.add("wk-pop")
  }
}
